import { render, staticRenderFns } from "./case-procedure-card.vue?vue&type=template&id=91efd3e8&scoped=true&"
import script from "./case-procedure-card.vue?vue&type=script&lang=js&"
export * from "./case-procedure-card.vue?vue&type=script&lang=js&"
import style0 from "./case-procedure-card.vue?vue&type=style&index=0&id=91efd3e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91efd3e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VHover,VIcon})
